import { render, staticRenderFns } from "./staffRegistration.vue?vue&type=template&id=6d94c2ea&scoped=true&"
import script from "./staffRegistration.vue?vue&type=script&lang=js&"
export * from "./staffRegistration.vue?vue&type=script&lang=js&"
import style0 from "./staffRegistration.vue?vue&type=style&index=0&lang=css&"
import style1 from "./staffRegistration.vue?vue&type=style&index=1&id=6d94c2ea&scoped=true&lang=css&"
import style2 from "./staffRegistration.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d94c2ea",
  null
  
)

export default component.exports